import { Col, Row } from "react-bootstrap";
import { LookupItem } from "../../Shared/Models/LookupItem";
import { getDateWithOffset } from "../../Shared/Utility/GetDateWithOffset";
import ResidentInformation from "../Models/ResidentInformation";

interface IProps {
    residentInfo: ResidentInformation;
    medicalEducationLookup: Array<LookupItem>;
}

export default function ResidentPersonalInformation(props: IProps) {

    return <div className="p-2 mt-2">
        <Row>
            <Col lg={4} >
                <span className="">Personal Information</span>
            </Col>
            <Col lg={8}>
                <Row>
                    <Col xs={12} lg={4}>
                        <div className="fw-bolder mb-1 vc-font-size-smaller">SSN4</div>
                        <div className="vc-font-size-smaller">{props.residentInfo.resident.ssn4}</div>
                    </Col>
                    <Col xs={12} lg={4}>
                        <div className="fw-bolder mb-1 vc-font-size-smaller">Date Of Birth</div>
                        <div className="vc-font-size-smaller">{getDateWithOffset(props.residentInfo.resident.dateOfBirth).toLocaleDateString()}</div>
                    </Col>
                </Row>
            </Col>
        </Row>
        <Row>
            <Col lg={{ span: 10, offset: 2 }}>
                <hr />
            </Col>
        </Row>
        <Row>
            <Col lg={4} >
                <span className="">Medical Education</span>
            </Col>
            <Col lg={8}>
                <Row>
                    <Col xs={12} lg={4}>
                        <div className="fw-bolder mb-1 vc-font-size-smaller">Location</div>
                        <div className="vc-font-size-smaller">{props.medicalEducationLookup.find(_ => _.id == props.residentInfo.medicalEducation?.locationId)?.name ?? "Unknown"}</div>
                    </Col>
                    <Col xs={12} lg={4}>
                        <div className="fw-bolder mb-1 vc-font-size-smaller">Graduation Year</div>
                        <div className="vc-font-size-smaller">{props.residentInfo.medicalEducation?.graduationYear ?? "Unknown"}</div>
                    </Col>
                    <Col xs={12} lg={4}>
                        <div className="fw-bolder mb-1 vc-font-size-smaller">Degree Type</div>
                        <div className="vc-font-size-smaller">{props.residentInfo.resident.name.title}</div>
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>

}